import React from "react";
import {Control} from "react-hook-form/dist/types";
import {Controller, FieldPath} from "react-hook-form";
import ComboBox from "./ComboBox";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {RegisterOptions} from "react-hook-form/dist/types/validator";

type Month = { id: number, name: string, max: number };


export function ComboBoxMesi<T extends FieldValues>(props: {
                                                        control: Control<T>, name: FieldPath<T>, defaultValue?: any,
                                                        label?: string, data: Month[] | undefined, isLoading?: boolean,
                                                        onChange?: (v: Month | null) => void,
                                                        rules?: Omit<RegisterOptions<T, FieldPath<T>>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>,
                                                        disabled?: boolean, classNameCombo?: string,
                                                    }
) {
    return <Controller name={props.name}
                       control={props.control}
                       defaultValue={props.defaultValue}
                       rules={{required: true}}
                       render={({field: {value, onChange}, fieldState}) => {
                           return (
                               <ComboBox<Month> label={props.label ? props.label : 'Mese'} value={{id: value}} onChange={(value) => {
                                   onChange(value?.id);
                                   if (props.onChange)
                                       props.onChange(value);
                               }} className={props.classNameCombo}
                                                data={props.data}
                                                isLoading={props.isLoading}
                                                searchablePropsName={["name"]}
                                                disabled={props.disabled}
                                                fieldState={fieldState}
                                                isSameFn={(a, z) => (a && z) ? a.id === z.id : false}
                                                keyValueFn={(v) => v.id!}
                                                displayValueFn={(v) => {
                                                    //console.log('displayValueFn',v)
                                                    //console.log('props.data',props.data)
                                                    return props.data && v ? v.name : '???';
                                                }}
                               />
                           )
                       }}
    />
}